import { AgGridReact } from "ag-grid-react";
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { AgTableClient, AgTableServer } from "app/shared/AgTable";
import { apiGet } from "app/services/apiServices";
import { handleCellRenderer } from "app/shared/AgTable/AgServerUtility";
import Loader from "app/shared/Loader";
import { Button } from "antd";
import { currentPDFData, userInfo } from "app/config/States/users";

import {
  API_ENDPOINT_RECON_HOTEL_NEW,
  API_ENDPOINT_RECON_ZA_AIRLINE_DATA,
} from "app/scenes/AppTour/onboarding.constants";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  RightCircleOutlined,
} from "@ant-design/icons";
import JsonData from "./demo.json";

import { tableSchema, agTableHotelType, agTableHotelData, tableLoadingState, hotelActiveTabAtom, hotelServerModeState } from "app/config/States/agtable";
import { getProcessedDefinition, getSubdomain } from "app/utils/generic.helper";
import FinkAI from "app/shared/FinkAI";
import { useRecoilState, useRecoilValue } from "recoil";

const ChildComponent = forwardRef((props: any, ref) => {
  const [pdfViewerData, setPdfViewerData] = useState("");
  const [tableSchemaInfo, setTableSchema] = useRecoilState<any>(tableSchema);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useRecoilState(hotelActiveTabAtom);
  const [serverPayload, setServerPayload] = useState(null);
  const [restoreStateOnServer, setRestoreStateOnServer] = useState(false);
  
  
  const openSidebarRenderer = (params: any) => {
    setPdfViewerData(params?.data);
    params.api.openToolPanel("pdfRenderer", { paramData: params });
  };
  
  useEffect(() => {
    getProcessedDefinitions();
  }, [tableSchemaInfo, activeTab]);

  useImperativeHandle(ref, () => ({
    createNewView(viewName: string) {
      gridRef.current?.saveGridView(viewName, props.moduleId);
    },
    loadTableView(viewId: string) {
      gridRef.current?.loadGridView(viewId, props.moduleId);
    },
    updateTableView(viewId: string) {
      gridRef.current?.updateGridView(viewId, props.moduleId);
    },
    exportDataToExcel() {
      gridRef.current?.exportDataToExcel();
    },
    getAllColumns() {
      return gridRef.current?.getAllColumns();
    },
    getGridState() {
      return gridRef.current?.getServerSidePayload();
    },
    getServerSidePayload() {
      return gridRef.current?.getServerSidePayload();
    },
  }));
  const [useServer, setUseServer] = useRecoilState(hotelServerModeState);
  const [rowData, setRowData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const gridRef: any = useRef();
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [finkDataset, setFinkDataset] = useState<any[]>([]);
  const [recoilPDFData, setRecoilPdfData] = useRecoilState<string>(currentPDFData);
  const [hotelType, setHotelType] = useRecoilState(agTableHotelType);
  const [hotelData, setHotelData] = useRecoilState(agTableHotelData);
  const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState);

  const getProcessedDefinitions = () => {
    if (!tableSchemaInfo || !tableSchemaInfo.length) return [];
    let columnObject;
    
    // First try to find by activeTab (which stores uniqueId - tableName or moduleId_index)
    // Check if activeTab is in format moduleId_index
    if (activeTab && activeTab.includes('_')) {
      const parts = activeTab.split('_');
      const index = parseInt(parts[parts.length - 1]); // Get the last part as index
      const moduleId = parts.slice(0, -1).join('_'); // Join all parts except the last one
      const matchingSchemas = tableSchemaInfo.filter((item: any) => item.moduleId === moduleId);

      if (matchingSchemas && matchingSchemas.length > 0) {
        columnObject = matchingSchemas[index] || matchingSchemas[0];
      }
    }
    
    // If not found, try to find by tableName (activeTab might be tableName)
    if (!columnObject && activeTab) {
      columnObject = tableSchemaInfo.find(
        (item: any) => item.table_name === activeTab || item.tableName === activeTab
      );
    }
    
    // If still not found, try to find by moduleId (activeTab might be moduleId)
    if (!columnObject && activeTab) {
      columnObject = tableSchemaInfo.find(
        (item: any) => item.moduleId === activeTab
      );
    }
    
    // Fallback to props.moduleId if still not found
    if (!columnObject && props.moduleId) {
      columnObject = tableSchemaInfo.find(
        (item: any) => item.moduleId === props.moduleId
      );
    }
    
    // Final fallback to props.tableName
    if (!columnObject && props.tableName) {
      columnObject = tableSchemaInfo.find(
        (item: any) => item.table_name === props.tableName
      );
    }
    
    let columnArray = columnObject?.state?.columnDefs || [];
    let finalDefs = getProcessedDefinition(
      columnArray,
      "SERVER",
      setRecoilPdfData
    );
    // setColumnDefs(finalDefs);
    return finalDefs;
  };

  const defaultFinkAction: any = [
    {
      name: "GST on Invoice Recevied Vs Not Received - Airline",
      model: {
        rowGroupCols: [
          { id: "Vendor2B", displayName: "Vendor", field: "Vendor2B" },
        ],
        filterModel: {},
        sortModel: [],
        pivotMode: true,
        pivotCols: [
          {
            id: "Main_Invoice_Status",
            displayName: "Invoice Status ",
            field: "Main_Invoice_Status",
          },
        ],
        valueCols: [
          {
            id: "TotalGST",
            aggFunc: "sum",
            displayName: "Total GST",
            field: "TotalGST",
          },
        ],
      },
    },
    {
      name: "Carrier wise Total Amount",
      model: {
        rowGroupCols: [
          { id: "Vendor2B", displayName: "Vendor", field: "Vendor2B" },
        ],
        filterModel: {},
        sortModel: [],
        pivotMode: true,
        pivotCols: [{ id: "Type2B", displayName: "Type", field: "Type2B" }],
        valueCols: [
          {
            id: "TotalAmount",
            aggFunc: "sum",
            displayName: "Total Amount",
            field: "TotalAmount",
          },
        ],
      },
    },
  ];

  const domain = getSubdomain();

  const handleStateChange = () => {
    if (gridRef.current) {
      const state = gridRef.current.getServerSidePayload();
      
      setUseServer(true);
      setServerPayload(state);
      setRestoreStateOnServer(true);
      
      
      setTimeout(() => {
        if (gridRef.current) {
          gridRef.current.loadGridView2(state);
        }
      }, 0);
    }
  };

  return (
    <div
      className="UnReconContainer"
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="ag-theme-alpine"
        style={{ flex: 1, width: "100%", height: "100%" }}
      >
        {isLoading ? (
          <div
            style={{
              height: "100%",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader title="fetching your booking data from Makemytrip" />
          </div>
        ) : !useServer && hotelType === "CLIENT" ? (
          <AgTableClient
            // @ts-ignore
            rowData={(hotelData as Record<string, any[]>)[activeTab] || []}
            columnDefs={getProcessedDefinitions()}
            groupPanel
            enablePDFViewer
            pdfV2
            pdfDataKey="Invoice_link"
            ref={gridRef}
            onGridReady={(params: any) => {
              const effectiveModuleId =
                userDetails?.currentWorkspace?.meta?.dataTable || props.moduleId;

              if (
                effectiveModuleId ===
                userDetails?.currentWorkspace?.meta?.dataTable &&
                activeTab === "0"
              ) {
                // Add any specific filters for hotel data if needed
                params.api.onFilterChanged();
              }
            }}
            onSortChanged={() => {
              handleStateChange();
            }}
            onFilterChanged={() => {
              handleStateChange();
            }}
            onColumnRowGroupChanged={() => {
              handleStateChange();
            }}
            onColumnPivotModeChanged={() => {
              handleStateChange();
            }}
            onColumnPivotChanged={() => {
              handleStateChange();
            }}
          />
        ) : (
          <AgTableServer
            //@ts-ignore
            {...{
              key: activeTab, // Force re-mount when activeTab changes
              rowSelection: "multiple",
              columnDefs: getProcessedDefinitions(),
               endpoint: API_ENDPOINT_RECON_HOTEL_NEW,
              //endpoint:"http://192.168.0.159:7003/api/misc/recon/za/hotel",
              pdfDataKey: "Invoice_link",
              enablePDFViewer: true,
              grandTotalRow: true,
              pdfV2: true,
              ref: gridRef,
              showStatusBar: true,
              state: { serverPayload },
              restoreStateOnServer: { restoreStateOnServer },
              setRestoreStateOnServer: { setRestoreStateOnServer },
              useWorkspace:
                userDetails?.currentWorkspace?.name === "MMT Admin"
                  ? false
                  : userDetails?.currentWorkspace?.meta?.full_access
                    ? false
                    : true,
              moduleId: (() => {
                const moduleId = props.moduleId || (() => {
                  if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) return activeTab;
                  
                  // Check if activeTab is in format moduleId_index
                  if (activeTab.includes("_")) {
                    const parts = activeTab.split("_");
                    const index = parseInt(parts[parts.length - 1]);
                    const moduleIdPrefix = parts.slice(0, -1).join("_");
                    const matchingSchemas = tableSchemaInfo.filter((item: any) => item.moduleId === moduleIdPrefix);
                    if (matchingSchemas && matchingSchemas.length > 0) {
                      return matchingSchemas[index]?.moduleId || matchingSchemas[0]?.moduleId || activeTab;
                    }
                  }
                  
                  // Try to find by table_name (activeTab might be table_name)
                  const schema = tableSchemaInfo.find(
                    (item: any) => item.table_name === activeTab || item.tableName === activeTab || item.moduleId === activeTab
                  );
                  return schema?.moduleId || activeTab;
                })();
                return moduleId;
              })(),
              tableName: (() => {
                const tableName = props.tableName || (() => {
                  if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) return undefined;
                  
                  // Check if activeTab is in format moduleId_index
                  if (activeTab.includes("_")) {
                    const parts = activeTab.split("_");
                    const index = parseInt(parts[parts.length - 1]);
                    const moduleIdPrefix = parts.slice(0, -1).join("_");
                    const matchingSchemas = tableSchemaInfo.filter((item: any) => item.moduleId === moduleIdPrefix);
                    if (matchingSchemas && matchingSchemas.length > 0) {
                      return matchingSchemas[index]?.table_name || matchingSchemas[0]?.table_name || undefined;
                    }
                  }
                  
                  // Try to find by table_name (activeTab might be table_name)
                  const schema = tableSchemaInfo.find(
                    (item: any) => item.table_name === activeTab || item.tableName === activeTab || item.moduleId === activeTab
                  );
                  return schema?.table_name || schema?.tableName || undefined;
                })();
                return tableName;
              })(),
              setData: (data: any) => setFinkDataset(data),
            }}
          />
        )}
      </div>
      <FinkAI
        onResponse={(config: any) =>
          gridRef.current && gridRef.current.applyTestView(config)
        }
        defaultActions={defaultFinkAction}
        columnDefs={getProcessedDefinitions()}
        dataset={finkDataset}
      />
    </div>
  );
});

export default ChildComponent;
